import React, { useEffect, useState } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { useAuth } from "../../contexts/authContext";
import userService from "../../services/userService";

type TParams = { username: string , token: string};

const LoginComponent = ({ match }: RouteComponentProps<TParams>) => {
  const [username, setUserName] = useState("");
  const [token, setToken] = useState("");
  const history = useHistory();
  const { login , authData } = useAuth();

  useEffect(() => {
    async function checkAuthntication() {
      await login(match.params.username, match.params.token);
      history.push('/home');
    }

    checkAuthntication();
  }, []);

  return (
    <div>
      <h5>Login</h5>
      <h5>User name : {authData?.userName}</h5>
    </div>
  );
};

export default LoginComponent;
